/**
 * 格式化bs账户分析资产数据（Marsco 使用单独接口需要额外处理）
 * @param {object} asset 资产分析数据
 * @param {boolean} isMarsco 是否是 marsco 清算
 *
 * @return {object} {summary, pnlRatio, assetHistory}
 */
export default function formatAnalyticsAsset(asset, isMarsco) {
  if (isMarsco) {
    const assetHistory = (asset.assetHistory || []).map(t => ({
      changeRatio: t.changeRatio,
      change: t.change,
      currency: t.currency,
      date: t.tradeDate,
      netLiq: t.netLiquidity
    }))
    const summary = asset.summary
    if (assetHistory.length > 0) {
      const netLiq = assetHistory[0].netLiq
      summary.pnl = summary.netLiq - netLiq
      summary.pnlRatio = summary.pnl / netLiq
    }
    return {
      summary,
      pnlRatio: asset.pnlRatios || [],
      assetHistory
    }
  }

  const newAsset = (asset.history || []).reduce(
    (acc, t) => {
      const pnlRatio = t.pnlPercentage / 100
      acc.assetHistory.push({
        ...t,
        netLiq: t.asset
      })
      acc.pnlRatio.push({
        pnlRatio,
        date: t.date
      })
      return acc
    },
    { pnlRatio: [], assetHistory: [], summary: null }
  )

  if (asset.summary) {
    newAsset.summary = {
      ...asset.summary,
      pnlRatio: asset.summary.pnlPercentage / 100,
      annualizedReturn: (asset.summary.annualizedReturn /= 100)
    }
  }

  return newAsset
}
